function meta (title, d) {
  // format title
  var t = 'Endorfine - ' + title

  // meta title
  document.title = t
  document.querySelector('meta[name="twitter:title"]').setAttribute('content', t)
  document.querySelector('meta[property="og:site_name"]').setAttribute('content', t)
  document.querySelector('meta[property="og:title"]').setAttribute('content', t)
  document.querySelector('meta[itemprop="name"]').setAttribute('content', t)

  // meta description
  document.querySelector('meta[name="description"]').setAttribute('content', d)
  document.querySelector('meta[name="twitter:description"]').setAttribute('content', d)
  document.querySelector('meta[property="og:description"]').setAttribute('content', d)
  document.querySelector('meta[itemprop="description"]').setAttribute('content', d)
}

export {meta}



// WEBPACK FOOTER //
// ./src/meta.js